import React from "react";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {},
	numberWrapper: {
		width: "100%",
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	numberText: {
		fontFamily: theme.fonts.bold,
		fontSize: "21px",
		lineHeight: "23px",
		color: theme.palette.colors.purplishBlue,
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		numberText: {
			fontFamily: theme.fonts.bold,
			fontSize: "18px",
			lineHeight: "20px",
			letterSpacing: "-.5px",
			color: theme.palette.colors.purplishBlue,
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		numberText: {
			fontFamily: theme.fonts.bold,
			fontSize: "18px",
			lineHeight: "20px",
			letterSpacing: "-.5px",
			color: theme.palette.colors.purplishBlue,
		},
	},
	[`@media (max-width: ${theme.media.xs})`]: {
		numberText: {
			fontFamily: theme.fonts.bold,
			fontSize: "18px",
			lineHeight: "20.5px",
			letterSpacing: "-.5px",
			color: theme.palette.colors.purplishBlue,
		},
		numberWrapper: {
			justifyContent: "flex-start",
		},
	},
});

const NumberComponent = ({ classes, value }) => (
	<div className={classes.numberWrapper}>
		<div className={classes.numberText}>{value}</div>
	</div>
);

export default withStyles(styles)(NumberComponent);
